module.exports = __webpack_public_path__ + "img/other.b9d3b3b4.svg";